import { VariaveisAmbiente } from "ambiente";
import { useApiBase } from "api/base";
import { useCallback } from "react";

export function useGetPedidosLista() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getPedidosLista = useCallback(
        (query: string, empresaId: string) => {
            return invocarApi({
                url: `api/v4/empresa/${empresaId}/pedidos/lista${query}`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'Domain': 'app.touchone.com.br',
                },
                enviarTokenUsuario: true,
                baseURL: VariaveisAmbiente.masterApi,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        getPedidosLista,
    };
}